"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SubNavHeading = require("@ccw-pwa-ui/SubNavHeading");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _SubHeading = require("@ccw-pwa-ui/SubHeading");
require("../styles/StoreDashBoardComponent.css");
var _OwnerMobileFirstVisitComponent = _interopRequireDefault(require("./OwnerMobileFirstVisitComponent"));
var _HomeDashboardStoreComponent = _interopRequireDefault(require("./HomeDashboardStoreComponent"));
var _StoreDashBoardFirstVisitComponent = _interopRequireDefault(require("./StoreDashBoardFirstVisitComponent"));
const OwnerDashBoardComponent = _ref => {
  let {
    stores,
    handleClick,
    storeItem,
    subHeading,
    heading,
    ownerMobileString,
    isLoading,
    separator,
    loginType,
    title,
    rightText,
    handleCreateStore,
    userType,
    headerText,
    string,
    mode,
    isDisableIcon,
    isDisableText,
    onScrollHandler,
    successLabel,
    everythingOkIcon,
    listInnerRef,
    ...rest
  } = _ref;
  const getSubDiv = () => {
    return rightText === 0 ? /*#__PURE__*/_react.default.createElement(_OwnerMobileFirstVisitComponent.default, {
      ownerMobileString: ownerMobileString,
      handleCreateStore: handleCreateStore
    }) : /*#__PURE__*/_react.default.createElement(_HomeDashboardStoreComponent.default, (0, _extends2.default)({
      stores: stores,
      handleClick: handleClick,
      loginType: loginType,
      handleCreateStore: handleCreateStore,
      userType: userType,
      isDisableIcon: isDisableIcon,
      isDisableText: isDisableText
    }, rest, {
      onScrollHandler: onScrollHandler,
      successLabel: successLabel,
      everythingOkIcon: everythingOkIcon,
      listInnerRef: listInnerRef
    }));
  };
  const getMainDiv = () => {
    return rightText === 0 && userType ? /*#__PURE__*/_react.default.createElement(_StoreDashBoardFirstVisitComponent.default, {
      headerText: headerText,
      string: string
    }) : getSubDiv();
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SubNavHeading.SubNavHeading, {
    heading: heading,
    subHeading: subHeading,
    separator: separator
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ownerDashboard-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: mode
  }, mode), isLoading ? null : rightText > 0 && /*#__PURE__*/_react.default.createElement(_SubHeading.SubHeading, {
    title: title,
    rightText: rightText
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ownerDashboard-body"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null)) : getMainDiv())));
};
var _default = exports.default = OwnerDashBoardComponent;